export function Amap() {
	return new Promise(function (resolve, reject) {
		window.initMap = function () {
			resolve(AMap);
		}
		var script = document.createElement("script");
		script.type = "text/javascript";
		script.src = "//webapi.amap.com/maps?v=1.4.1&key=d519afcda375cc340f7cfc0ec94a7414&callback=initMap";
		script.onerror = reject;
		document.head.appendChild(script);
	})
}


// WEBPACK FOOTER //
// ./src/config/AMap.js